import {navInit} from './scripts/navigation';
import {slickInit} from './scripts/slick';
import {modalInit} from './scripts/modals';

navInit();
slickInit();


jQuery(document).ready(function ( $ ) {

  if($('.section_card_modalDownload')) {
    modalInit();
  }

  // smooth scroll to ID
  $('.menu-item a[href*="#"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - 120 // choose what you need
    }, 500, 'linear');
  });

}); 